import { useState } from 'react';
import { compressMedia, formatBytes, getFileInfo } from './mediaCompression';

export const useCompressedUpload = () => {
  const [isCompressing, setIsCompressing] = useState(false);
  const [compressionProgress, setCompressionProgress] = useState(0);
  const [originalFileInfo, setOriginalFileInfo] = useState(null);
  const [compressedFileInfo, setCompressedFileInfo] = useState(null);

  const processFile = async (file, onProgress) => {
    // Log upload start
    
    // Store original file info
    const originalInfo = getFileInfo(file);
    setOriginalFileInfo(originalInfo);
    
    // console.table(originalInfo);
    
    setIsCompressing(true);
    
    try {
      // Simulate progress
      const interval = setInterval(() => {
        setCompressionProgress(prev => Math.min(prev + 10, 90));
        if (onProgress) onProgress(compressionProgress);
      }, 100);
      
      const compressed = await compressMedia(file);
      
      clearInterval(interval);
      setCompressionProgress(100);
      
      // Store compressed file info
      const compressedInfo = getFileInfo(compressed);
      setCompressedFileInfo(compressedInfo);
      
      // console.table(compressedInfo);
      
      // Calculate and log savings
      const savedBytes = originalInfo.size - compressedInfo.size;
      const savedPercent = ((savedBytes / originalInfo.size) * 100).toFixed(1);
  
      await new Promise(resolve => setTimeout(resolve, 200));
      
      return compressed;
      
    } catch (error) {
      console.error('%c❌ COMPRESSION ERROR:', 'color: #f44336; font-weight: bold', error);
      return file;
    } finally {
      setIsCompressing(false);
      setCompressionProgress(0);
    }
  };

  const reset = () => {
    setOriginalFileInfo(null);
    setCompressedFileInfo(null);
    setCompressionProgress(0);
  };

  return {
    processFile,
    isCompressing,
    compressionProgress,
    originalFileInfo,
    compressedFileInfo,
    reset
  };
};